<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-content">
        <div class="branding">
          <router-link to="/" class="logo-link">
            <img :src="footerLogo" alt="Discover China Today logo" />
          </router-link>
          <p class="tagline">
            Curated travel stories, culture highlights, and timeless guides to help you explore China with confidence.
          </p>
        </div>
        <div class="legacy-links">
          <h4>Legacy Links</h4>
          <p>Still popular with our readers? They remain online.</p>
          <ul>
            <li v-for="link in legacyLinks" :key="link.path">
              <a :href="link.path">{{ link.label }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer-meta">
        <p>&copy; {{ currentYear }} Discover China Today. All rights reserved.</p>
        <a class="email" href="mailto:info@discoverchinatoday.com">info@discoverchinatoday.com</a>
      </div>
    </div>
  </footer>
</template>

<script>
import footerLogo from '@/assets/images/footer-logo.png';
import legacyLinks from '@/data/legacyLinks';

export default {
  name: 'Footer',
  data() {
    return {
      footerLogo,
      legacyLinks,
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.site-footer {
  background-color: var(--neutral-50);
  border-top: 1px solid var(--neutral-200);
  padding: var(--space-10) 0;
  font-size: var(--text-sm);
  color: var(--neutral-600);
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: var(--space-8);
  margin-bottom: var(--space-6);
}

.logo-link img {
  height: 40px;
}

.tagline {
  margin-top: var(--space-3);
  line-height: var(--leading-relaxed);
}

.legacy-links h4 {
  margin-bottom: var(--space-2);
  font-size: var(--text-base);
  color: var(--neutral-800);
}

.legacy-links p {
  margin-bottom: var(--space-3);
}

.legacy-links ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--space-2);
}

.legacy-links a {
  text-decoration: none;
  color: var(--neutral-700);
  transition: color var(--transition-fast);
}

.legacy-links a:hover {
  color: var(--brand-primary, var(--neutral-900));
}

.footer-meta {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--space-4);
  border-top: 1px solid var(--neutral-200);
  padding-top: var(--space-4);
}

.footer-meta .email {
  color: var(--neutral-700);
}

@media (max-width: 640px) {
  .legacy-links ul {
    grid-template-columns: 1fr;
  }
}
</style>
